import { render, staticRenderFns } from "./WritingTaskConfig.vue?vue&type=template&id=cc167336"
import script from "./WritingTaskConfig.vue?vue&type=script&lang=js"
export * from "./WritingTaskConfig.vue?vue&type=script&lang=js"
import style0 from "./WritingTaskConfig.vue?vue&type=style&index=0&id=cc167336&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports